"use strict";
exports.__esModule = true;
var config_1 = require("../config/config");
var AccountLoginPage = /** @class */ (function () {
    function AccountLoginPage() {
        this.store = window[config_1["default"].storeKey];
        this.init();
    }
    AccountLoginPage.prototype.init = function () {
        this.bindEvents();
    };
    ;
    AccountLoginPage.prototype.bindEvents = function () {
        var _this = this;
        $(document).on('click', this.store.selectors.account.registerSubmitBtn, function (e) {
            _this.onRegisterBtnClickEvent();
        });
        $(document).on('blur', this.store.selectors.account.firstNameInput, function () {
            _this.validateInput(_this.store.selectors.account.firstNameInput);
        });
        $(document).on('blur', this.store.selectors.account.lastNameInput, function () {
            _this.validateInput(_this.store.selectors.account.lastNameInput);
        });
        $(document).on('blur', this.store.selectors.account.emailInput, function () {
            _this.validateEmail();
        });
        $(document).on('blur', this.store.selectors.account.passwordInput, function () {
            _this.validatePassword();
        });
        $(document).on('change', this.store.selectors.account.genderSelect, function () {
            _this.validateSelect(_this.store.selectors.account.genderSelect);
        });
        $(document).on('blur', this.store.selectors.account.phoneNumberInput1, function () {
            _this.validatePhone1();
        });
        $(document).on('keyup', this.store.selectors.account.codeInput, function () {
            var isCodeValid = _this.validateCode();
            _this.toggleSubmitButton(isCodeValid);
        });
        $(document).on('blur', this.store.selectors.account.addressInput1, function () {
            _this.validateInput(_this.store.selectors.account.addressInput1);
        });
        $(document).on('change', this.store.selectors.account.cityInput, function () {
            _this.validateSelect(_this.store.selectors.account.cityInput);
        });
        $(document).on('change', this.store.selectors.account.districtInput, function () {
            _this.validateSelect(_this.store.selectors.account.districtInput);
            setTimeout(function () {
                _this.validateInput(_this.store.selectors.account.zipInput);
            }, 100);
        });
        $(document).on('blur', this.store.selectors.account.zipInput, function () {
            _this.validateInput(_this.store.selectors.account.zipInput);
        });
        $(document).on('change', this.store.selectors.account.birthdayDaySelect, function () {
            _this.validateSelect(_this.store.selectors.account.birthdayDaySelect);
        });
        $(document).on('change', this.store.selectors.account.birthdayMonthSelect, function () {
            _this.validateSelect(_this.store.selectors.account.birthdayMonthSelect);
        });
        $(document).on('keyup', this.store.selectors.account.phoneNumberInput1, function () {
            _this.updateSendCodeButtonStatus();
        });
        $(document).on('click', this.store.selectors.account.sendCodeBtn, function () {
            _this.onSendVerificationCodeBtnClickEvent();
        });
    };
    ;
    AccountLoginPage.prototype.updateSendCodeButtonStatus = function () {
        var sendCodeButton = $(this.store.selectors.account.sendCodeBtn);
        if (!this.validatePhone1()) {
            sendCodeButton.prop('disabled', true);
        }
        else {
            sendCodeButton.prop('disabled', false);
        }
    };
    ;
    AccountLoginPage.prototype.onSendVerificationCodeBtnClickEvent = function () {
        var _this = this;
        if (!this.validatePhone1()) {
            return alert('Phone number require 8 numbers'); //'Phone number require 9 numbers'
        }
        var phoneNumber = this.getPhoneNumber();
        // @ts-ignore
        var token = grecaptcha.getResponse();
        if (token.length === 0) {
            alert("Please confirm that you are not a robot");
            return;
        }
        var sendCodeButton = $(this.store.selectors.account.sendCodeBtn);
        sendCodeButton.prop('disabled', true);
        $.post(this.store.commonApiUrl + 'customers/phone-code/' + phoneNumber + '/' + token, function (response) {
            if (!response) {
                return alert(_this.store.serverErrorMessage);
            }
            if (!response.success) {
                return alert(_this.store.serverErrorMessage);
            }
            alert(response.data.message);
            sendCodeButton.prop('disabled', false);
        }).fail(function () {
            return alert(_this.store.serverErrorMessage);
        });
    };
    ;
    AccountLoginPage.prototype.onRegisterBtnClickEvent = function () {
        var isFormValid = this.validateFormData();
        console.log(isFormValid);
        if (!isFormValid) {
            return;
        }
        this.createCustomer();
    };
    ;
    AccountLoginPage.prototype.createCustomer = function () {
        var _this = this;
        var data = this.collectFormData();
        var loadingOverlay = $(this.store.selectors.account.loadingOverlay);
        loadingOverlay.show();
        $.post(this.store.commonApiUrl + '/customers', data, function (response) {
            if (!response) {
                loadingOverlay.hide();
                return alert(_this.store.serverErrorMessage);
            }
            if (!response.success) {
                loadingOverlay.hide();
                return alert(_this.store.serverErrorMessage);
            }
            if (!response.data.success) {
                loadingOverlay.hide();
                var msg = response.data.message;
                return alert(msg);
            }
            if (!response.data.url) {
                loadingOverlay.hide();
                return alert(_this.store.serverErrorMessage);
            }
            window.location.href = response.data.url;
        })
            .fail(function () {
            return alert(_this.store.serverErrorMessage);
        });
    };
    ;
    AccountLoginPage.prototype.collectFormData = function () {
        return {
            firstName: $(this.store.selectors.account.firstNameInput).val(),
            lastName: $(this.store.selectors.account.lastNameInput).val(),
            email: $(this.store.selectors.account.emailInput).val(),
            password: $(this.store.selectors.account.passwordInput).val(),
            gender: $(this.store.selectors.account.genderSelect).val(),
            phoneNumber: this.getPhoneNumber(),
            code: $(this.store.selectors.account.codeInput).val(),
            address1: $(this.store.selectors.account.addressInput1).val(),
            city: $(this.store.selectors.account.cityInput).val(),
            district: $(this.store.selectors.account.districtInput).val(),
            zip: $(this.store.selectors.account.zipInput).val(),
            birthdayDay: $(this.store.selectors.account.birthdayDaySelect).val(),
            birthdayMonth: $(this.store.selectors.account.birthdayMonthSelect).val(),
            receivePromotion: $(this.store.selectors.account.receivePromotionCheckbox).is(':checked'),
            receiveEmail: $(this.store.selectors.account.receiveEmailCheckbox).is(':checked'),
            receiveSms: $(this.store.selectors.account.receiveSmsCheckbox).is(':checked'),
            terms: $(this.store.selectors.account.termsCheckbox).is(':checked'),
            subscribeNews: $(this.store.selectors.account.subscribeNewsCheckbox).is(':checked')
        };
    };
    ;
    AccountLoginPage.prototype.validateFormData = function () {
        var result = true;
        if (!this.validateInput(this.store.selectors.account.firstNameInput)) {
            console.log('invalid fn');
            result = false;
        }
        if (!this.validateInput(this.store.selectors.account.lastNameInput)) {
            console.log('invalid ln');
            result = false;
        }
        if (!this.validateEmail()) {
            console.log('invalid email');
            result = false;
        }
        if (!this.validatePassword()) {
            console.log('invalid pass');
            result = false;
        }
        if (!this.validateSelect(this.store.selectors.account.genderSelect)) {
            console.log('invalid gen');
            result = false;
        }
        if (!this.validateSelect(this.store.selectors.account.birthdayDaySelect)) {
            console.log('invalid birth day');
            result = false;
        }
        if (!this.validateSelect(this.store.selectors.account.birthdayMonthSelect)) {
            console.log('invalid birth month');
            result = false;
        }
        if (this.validatePhone1() === false) {
            console.log('invalid phone1');
            result = false;
        }
        if (!this.validateCode()) {
            console.log('invalid code');
            result = false;
        }
        if (!this.validateInput(this.store.selectors.account.addressInput1)) {
            console.log('invalid address1');
            result = false;
        }
        if (!$(this.store.selectors.account.termsCheckbox).is(':checked')) {
            if (result) {
                alert('Please accept terms and conditions'); //'Please accept terms and conditions'
            }
            result = false;
        }
        return result;
    };
    ;
    AccountLoginPage.prototype.validateEmail = function () {
        var isEmailValid = true;
        var emailInput = $(this.store.selectors.account.emailInput);
        var email = emailInput.val();
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(String(email).toLowerCase())) {
            isEmailValid = false;
            emailInput.addClass('invalid');
        }
        if (isEmailValid) {
            emailInput.removeClass('invalid');
        }
        return isEmailValid;
    };
    ;
    AccountLoginPage.prototype.validatePassword = function () {
        var isPasswordValid = true;
        var passwordInput = $(this.store.selectors.account.passwordInput);
        var password = passwordInput.val().toString();
        if (!password) {
            isPasswordValid = false;
            passwordInput.addClass('invalid');
        }
        if (password.length < 5) {
            isPasswordValid = false;
            passwordInput.addClass('invalid');
        }
        if (isPasswordValid) {
            passwordInput.removeClass('invalid');
        }
        return isPasswordValid;
    };
    ;
    AccountLoginPage.prototype.validateSelect = function (selector) {
        var isSelectValid = true;
        var select = $(selector);
        var selectValue = select.val();
        if (!selectValue) {
            isSelectValid = false;
            select.addClass('invalid');
        }
        else {
            select.removeClass('invalid');
        }
        return isSelectValid;
    };
    ;
    AccountLoginPage.prototype.validatePhone1 = function () {
        var isPhoneValid = true;
        var phoneNumberInput1 = $(this.store.selectors.account.phoneNumberInput1);
        var phoneNumber1 = phoneNumberInput1.val().toString();
        if (!phoneNumber1) {
            isPhoneValid = false;
            phoneNumberInput1.addClass('invalid');
        }
        if (phoneNumber1.length < 8 || phoneNumber1.length > 10) {
            isPhoneValid = false;
            phoneNumberInput1.addClass('invalid');
        }
        if (!/^\d+$/.test(phoneNumber1)) {
            isPhoneValid = false;
            phoneNumberInput1.addClass('invalid');
        }
        if (isPhoneValid) {
            phoneNumberInput1.removeClass('invalid');
        }
        return isPhoneValid;
    };
    ;
    AccountLoginPage.prototype.validateCode = function () {
        var isCodeValid = true;
        var codeInput = $(this.store.selectors.account.codeInput);
        var code = codeInput.val().toString();
        if (!code) {
            isCodeValid = false;
        }
        if (code.length !== 6) {
            isCodeValid = false;
        }
        if (!/^\d+$/.test(code)) {
            isCodeValid = false;
        }
        if (isCodeValid) {
            codeInput.removeClass('invalid');
        }
        else {
            codeInput.addClass('invalid');
        }
        return isCodeValid;
    };
    ;
    AccountLoginPage.prototype.validateInput = function (selector) {
        var isInputValid = true;
        var input = $(selector);
        var inputValue = input.val();
        if (!inputValue) {
            isInputValid = false;
            input.addClass('invalid');
        }
        else {
            input.removeClass('invalid');
        }
        return isInputValid;
    };
    ;
    AccountLoginPage.prototype.getPhoneNumber = function () {
        return '+'
            + $(this.store.selectors.account.phoneNumberCodeSelect).val().toString()
            + $(this.store.selectors.account.phoneNumberInput1).val().toString();
    };
    ;
    AccountLoginPage.prototype.toggleSubmitButton = function (isCodeValid) {
        $(this.store.selectors.account.registerSubmitBtn).prop('disabled', !isCodeValid);
    };
    ;
    return AccountLoginPage;
}());
exports["default"] = AccountLoginPage;
